import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { TopBarFull } from '../TopBarFull';
import { TopBarFullCtaColors, TopBarFullImageSizes } from '../TopBarFullEnums';
import upgradeImage from '../assets/UCS_Top_Bar_Upgrade-color.png';

const COPY = defineMessages({
  HEADLINE: {
    id: 'BasicPendingInvoiceTopBarFull.headline',
    defaultMessage: 'Complete your purchase today',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'BasicPendingInvoiceTopBarFull.message',
    defaultMessage:
      'Start using the paid features and tools you wanted. Pay your pending invoice today.',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'BasicPendingInvoiceTopBarFull.ctaText',
    defaultMessage: 'PAY INVOICE',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

export const BasicPendingInvoiceTopBarFull: React.FC = () => {
  return (
    <TopBarFull
      headline={t(COPY.HEADLINE)}
      message={t(COPY.MESSAGE)}
      image={() => <img src={upgradeImage} aria-hidden="true" />}
      imageSize={TopBarFullImageSizes.large}
      ctaColor={TopBarFullCtaColors.upgrade}
      ctaText={t(COPY.CTA_TEXT)}
      ctaLink={createURL(`/billing/history/`, {
        ut_source: 'topbar',
        ut_source2: 'basic_pending_invoice',
      })}
    />
  );
};

export default BasicPendingInvoiceTopBarFull;
